import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/components/NotFound'
import Home from '@/components/Home'

Vue.use(Router)

// Create the router
const router = new Router({
  mode: 'history',
  base: __dirname,
  linkActiveClass: '-active',
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        default: Home
      },
      meta: { requiresAuth: true }
    },
    {
      path: '*',
      name: 'not-found',
      component: NotFound
    }
  ]
})

/**
* Before a route is resolved we check for
* the token if the route is marked as
* requireAuth.
*/
// router.beforeEach(beforeEach)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js